// import { useEffect, useRef, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useUser } from '../UserContext';

// // Default values
// const DEFAULT_INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes
// const DEFAULT_WARNING_TIMEOUT = 30 * 1000; //  30 second before timeout

// const useInactivityTimer = (inactivityTimeout = DEFAULT_INACTIVITY_TIMEOUT, warningTimeout = DEFAULT_WARNING_TIMEOUT) => {
//     const navigate = useNavigate();
//     const { logoutUser } = useUser();
//     const timeoutRef = useRef(null);
//     const warningTimeoutRef = useRef(null);
//     const [showWarning, setShowWarning] = useState(false);
//     const [timeLeft, setTimeLeft] = useState(Math.floor(warningTimeout / 1000));

//     const resetTimer = () => {
//         if (timeoutRef.current) {
//             clearTimeout(timeoutRef.current);
//         }
//         if (warningTimeoutRef.current) {
//             clearTimeout(warningTimeoutRef.current);
//         }
//         setShowWarning(false);
        
//         // Set warning timeout
//         warningTimeoutRef.current = setTimeout(() => {
//             setShowWarning(true);
//             // Start countdown
//             let countdown = Math.floor(warningTimeout / 1000);
//             const countdownInterval = setInterval(() => {
//                 countdown--;
//                 setTimeLeft(countdown);
//                 if (countdown <= 0) {
//                     clearInterval(countdownInterval);
//                 }
//             }, 1000);
//         }, inactivityTimeout - warningTimeout);

//         // Set logout timeout
//         timeoutRef.current = setTimeout(() => {
//             logoutUser();
//             navigate('/login');
//         }, inactivityTimeout);
//     };

//     const handleStayLoggedIn = () => {
//         resetTimer();
//     };

//     useEffect(() => {
//         // Events to track user activity
//         const events = [
//             'mousedown',
//             'mousemove',
//             'keypress',
//             'scroll',
//             'touchstart',
//             'click'
//         ];

//         // Add event listeners
//         events.forEach(event => {
//             window.addEventListener(event, resetTimer);
//         });

//         // Initial timer setup
//         resetTimer();

//         // Cleanup function
//         return () => {
//             if (timeoutRef.current) {
//                 clearTimeout(timeoutRef.current);
//             }
//             if (warningTimeoutRef.current) {
//                 clearTimeout(warningTimeoutRef.current);
//             }
//             events.forEach(event => {
//                 window.removeEventListener(event, resetTimer);
//             });
//         };
//     }, [navigate, logoutUser, inactivityTimeout, warningTimeout]);

//     return {
//         showWarning,
//         timeLeft,
//         handleStayLoggedIn
//     };
// };

// export default useInactivityTimer; 

import { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';

// Default values
const DEFAULT_INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutes
const DEFAULT_WARNING_TIMEOUT = 30 * 1000;       // 30 seconds before logout

const useInactivityTimer = (
  inactivityTimeout = DEFAULT_INACTIVITY_TIMEOUT,
  warningTimeout = DEFAULT_WARNING_TIMEOUT
) => {
  const navigate = useNavigate();
  const { logoutUser } = useUser();
  const timeoutRef = useRef(null);
  const warningTimeoutRef = useRef(null);
  const [showWarning, setShowWarning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(Math.floor(warningTimeout / 1000));

  const resetTimer = useCallback(() => {
    // Clear any existing timeouts
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (warningTimeoutRef.current) {
      clearTimeout(warningTimeoutRef.current);
    }
    setShowWarning(false);

    // Schedule the warning popup
    warningTimeoutRef.current = setTimeout(() => {
      setShowWarning(true);

      // start countdown
      let countdown = Math.floor(warningTimeout / 1000);
      const countdownInterval = setInterval(() => {
        countdown--;
        setTimeLeft(countdown);
        if (countdown <= 0) {
          clearInterval(countdownInterval);
        }
      }, 1000);
    }, inactivityTimeout - warningTimeout);

    // Schedule the actual logout
    timeoutRef.current = setTimeout(() => {
      logoutUser();
      navigate('/login');
    }, inactivityTimeout);
  }, [inactivityTimeout, warningTimeout, logoutUser, navigate]);

  const handleStayLoggedIn = () => {
    resetTimer();
  };

  useEffect(() => {
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click',
    ];

    // Any user interaction should reset the timers
    events.forEach((evt) => {
      window.addEventListener(evt, resetTimer);
    });

    // Kick off the first timer when the hook mounts
    resetTimer();

    return () => {
      // cleanup all timeouts and event listeners
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      if (warningTimeoutRef.current) {
        clearTimeout(warningTimeoutRef.current);
      }
      events.forEach((evt) => {
        window.removeEventListener(evt, resetTimer);
      });
    };
  }, [resetTimer]); // now resetTimer is stable (useCallback), so we list it here

  return {
    showWarning,
    timeLeft,
    handleStayLoggedIn,
  };
};

export default useInactivityTimer;
